import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Button } from '@material-ui/core';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import {
  clearCurrentUserCallState,
  getProfileRedirectUrl,
  signalChannelSessionEnded,
} from '../../../utils/videoCallFirestore';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      background: theme.brand,
      color: '#FFFFFF',
      '&:hover': {
        background: '#600101',
      },
    },
  })
);

export default function EndCallButton(props: { className?: string }) {
  const classes = useStyles();
  const { room } = useVideoContext();

  const onDisconnect = () => {
    const channelName = room?.channelName;
    const remoteCount = room?.client?.remoteUsers?.length ?? 0;
    // If this call has only two participants total (me + 1 remote), disconnect should end for both.
    // For 3+ participants, disconnect remains user-only and should not force-end others.
    const shouldEndSessionForEveryone = remoteCount <= 1;

    const leave = async () => {
      try {
        await clearCurrentUserCallState(room?.localParticipant?.identity, {
          agoraUid: room?.localParticipant?.uid,
          channelName: room?.channelName,
        });
      } catch (e) {
        console.error('clearCurrentUserCallState:', e);
      }
      if (shouldEndSessionForEveryone && channelName) {
        try {
          await signalChannelSessionEnded(channelName);
        } catch (e) {
          console.error('signalChannelSessionEnded:', e);
        }
      }
      try {
        // Wait for Agora leave to complete so remote peers receive `user-left`
        // before this page redirects/unloads.
        if (room?.leave) {
          await room.leave();
        } else {
          room?.disconnect();
        }
      } catch (e) {
        console.error(e);
      }
      window.location.replace(getProfileRedirectUrl());
    };

    // 2-person call: force end for both.
    // 3+ person call: keep existing members connected.
    void leave();
  };

  return (
    <Button onClick={() => onDisconnect()} className={clsx(classes.button, props.className)} data-cy-disconnect>
      Disconnect
    </Button>
  );
}
